import services from "@/services";

const state = {
  items: [],
  data: {},
  sla: {},
  bankList: [],
  statusSubmit: false,
};
const getters = {
  sellerItems: (state) => state.items,
  sellerDetail: (state) => state.data,
};

const mutations = {
  setSellerItems: (state, items) => {
    state.items = items;
  },
  setSellerDetail: (state, data) => {
    state.data = data;
  },
  setSLA: (state, data) => {
    state.data = data;
  },
  successSubmit: (state, status) => {
    state.statusSubmit = status;
  },
  storeBankList(state, data) {
    state.bankList = data;
  },
};

const actions = {
  getAll({ commit, dispatch }, param) {
    dispatch("setLoadingTable", true, { root: true });
    services.setHeader();
    return new Promise((resolve, reject) => {
      services
        .get("seller", param)
        .then((response) => {
          commit("setSellerItems", response.data.data.items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          dispatch("setLoadingTable", false, { root: true });
        });
    });
  },
  getById({ commit, dispatch }, id) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true });
    return new Promise((resolve, reject) => {
      services
        .get("seller/" + id)
        .then((response) => {
          commit("setSellerDetail", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          dispatch("setLoadingGlobal", false, { root: true });
        });
    });
  },
  updateSeller({ commit, dispatch }, payload) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true });
    return new Promise((resolve, reject) => {
      services
        .put("seller/" + payload.id, payload.body)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          dispatch("setLoadingGlobal", false, { root: true });
        });
    });
  },
  getBankList({ commit }) {
    return new Promise((resolve, reject) => {
      services
        .get("bank")
        .then((response) => {
          commit("storeBankList", response.data.data.items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getSLA({ commit, dispatch }) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true });
    return new Promise((resolve, reject) => {
      services
        .get("sla")
        .then((response) => {
          commit("setSLA", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          dispatch("setLoadingGlobal", false, { root: true });
        });
    });
  },
  submitSLA({ commit, dispatch }, payload) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true });
    return new Promise((resolve, reject) => {
      services
        .put("sla", payload)
        .then((response) => {
          commit("successSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          dispatch("setLoadingGlobal", false, { root: true });
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
